// src/services/adminClient.js
// Cliente HTTP del panel admin. Sesión SEPARADA del app de usuarios:
// el token vive en sessionStorage (no en localStorage del usuario), así un
// empleado puede usar /admin sin estar logueado en el app normal.
import { API_URL } from './apiClient';

const KEY = 'bitplify_admin_token';

export const getAdminToken   = () => sessionStorage.getItem(KEY);
export const setAdminToken   = (t) => sessionStorage.setItem(KEY, t);
export const clearAdminToken = () => sessionStorage.removeItem(KEY);

export async function adminFetch(path, options = {}) {
  const token   = getAdminToken();
  const headers = { 'Content-Type': 'application/json', ...(options.headers || {}) };
  if (token) headers.Authorization = `Bearer ${token}`;

  const res = await fetch(`${API_URL}${path}`, { ...options, headers });

  // Sesión admin inválida/expirada → limpiar y volver al login admin.
  const isLogin = path.endsWith('/admin/login');
  if ((res.status === 401 || res.status === 403) && token && !isLogin) {
    clearAdminToken();
    if (window.location.pathname.startsWith('/admin')) window.location.reload();
  }
  return res;
}
